type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH' | 'HEAD' | 'OPTIONS';

export function useWwwFetch<RespT>({ url, method }: { url: URL; method: HttpMethod }) {
  const data = $fetch<RespT>(url.toString(), {
    method: method,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return data;
}
